import { render } from "./EventUser.vue?vue&type=template&id=6bd094b2&scoped=true"
import script from "./EventUser.vue?vue&type=script&lang=js"
export * from "./EventUser.vue?vue&type=script&lang=js"

import "./EventUser.vue?vue&type=style&index=0&id=6bd094b2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd094b2"]])

export default __exports__